import { Injectable } from '@angular/core';
import { firstValueFrom } from 'rxjs';
import { AbstractApi } from './abstract.api';
import { User } from './profil.api';

export interface Company {
  id?: string;
  name?: string;
  siret?: string;
  email?: string;
  address?: string;
  type?: string | null;
  allowSubCompany?: boolean | null;
  allowDelegateAssistance?: boolean | null;
  parent?: Company;
  companyParentId?: string;
  shareAlias?: string;

  currentRelation?: CompanyRelation;
}
export interface CompanyRelation {
  rank: string;
}

export interface CompanyList {
  count: number;
  data: Company[];
}

@Injectable({
  providedIn: 'root',
})
export class CompanyApi extends AbstractApi {
  public getCompanies(
    length = 20,
    offset = 0,
    search: string = '',
    order: string = 'id',
    direction: string = 'ASC',
    parentId: string | null = null,
    onlyRoot: boolean = false,
  ): Promise<CompanyList> {
    const params: any = {
      length,
      offset,
      search,
      order,
      direction,
    };

    if (parentId) {
      params.parentId = parentId;
    }

    if (onlyRoot) {
      params.onlyRoot = true;
    }

    return firstValueFrom(
      this.http.get<CompanyList>(`${this.backend}/api/v1/companies`, {
        params: params,
      }),
    );
  }

  public postCompany(company: Company): Promise<Company> {
    return firstValueFrom(
      this.http.post<Company>(`${this.backend}/api/v1/companies`, company),
    );
  }

  public getCompany(companyId: string): Promise<Company> {
    return firstValueFrom(
      this.http.get<Company>(`${this.backend}/api/v1/companies/${companyId}`),
    );
  }

  public patchCompany(idCompany: string, company: Company): Promise<Company> {
    return firstValueFrom(
      this.http.patch<Company>(
        `${this.backend}/api/v1/companies/${idCompany}`,
        company,
      ),
    );
  }

  public deleteCompany(idCompany: string): Promise<Company> {
    return firstValueFrom(
      this.http.delete<Company>(
        `${this.backend}/api/v1/companies/${idCompany}`,
      ),
    );
  }
}
